import { put } from 'redux-saga/effects';
import { all, call, takeLatest } from 'redux-saga/effects';

import api from '../../core/api';
import { notificationError, notificationWarning } from '../../core/helpers/utils/notificationUtils';
import { getStorageErrors } from './storage.actions';

function* getErrorsSaga() {
  try {
    const resourcesInfo = yield call(api.storage.getResourcesInfo);
    const resourcesPath = resourcesInfo.resources[0].path;
    const errorsFolder = yield call(api.storage.getFile, `${resourcesPath}/di:Feed/di:Errors`);
    if (errorsFolder && errorsFolder.length > 0) {
      yield put(notificationWarning('widget:suspicious_dates_error'));
    }
  } catch (err) {
    yield put(notificationError('common:generic_error'));
  }
}

export function* watchStorageSaga() {
  yield all([yield takeLatest(getStorageErrors.started, getErrorsSaga)]);
}
